import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react';
import WebSocketUtil from '../../../../../../common/utils/socketUtil';
import { ScoreDetailService } from '../../../../../../common/services';

const SoccerTimeLineStore = () => {
  let store = useLocalStore(() => ({
    timeLine: [],
    isSub: false,
    gameId: null,
    socket: null,
    loading: true,
    connectSocket(topic, sportsType) {
      store.socket = new WebSocketUtil(topic);

      store.socket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;

          try {
            if (data === 'OK') {
              this.isSub = true;
            } else {
              let messageData = JSON.parse(data);

              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;
                const data = JSON.parse(MESSAGE);

                if (+store.gameId === data.gameId) {
                  store.timeLine = data.broadcasts;
                }
              }
            }
          } catch (error) {
            console.log('=== socket on message error ===', error);
          }
        }
      };
    },
    async getBrodcasts(id) {
      if (!store.isSub) {
        store.connectSocket([`sports.soccer.broadcasts.${id}`]);
      }

      const result = await ScoreDetailService.getBroadcastsBySportsType(
        'soccer',
        id
      );

      store.loading = false;
      if (result.length > 0) {
        store.timeLine = result;
        store.gameId = id;
      }
    },
    closeSocket() {
      store.socket.close(() => {
        store.isSub = false;
        store.socket = null;
      });
    }
  }));

  return {
    loading: store.loading,
    getBrodcasts: store.getBrodcasts,
    closeSocket: store.closeSocket,
    timeLine: useObserver(() => {
      return store.timeLine.toJS();
    })
  };
};

export default SoccerTimeLineStore;
